import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=f7f6f03c&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=f7f6f03c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7f6f03c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7f6f03c')) {
      api.createRecord('f7f6f03c', component.options)
    } else {
      api.reload('f7f6f03c', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=f7f6f03c&scoped=true&", function () {
      api.rerender('f7f6f03c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/center/head/detail.vue"
export default component.exports